<template>

  <detail-page-shell
    compact-header
    :back-to="'/lead/list'"
    :back-text="$t('common.backToList')"
  >

    <template #actions>

      <el-button size="small" type="success" @click="openQuoteForLead">{{ $t('leadDetailPage.newQuote') }}</el-button>

    </template>



    <el-card v-loading="loading" shadow="never">

      <el-tabs v-model="tab">

        <el-tab-pane :label="$t('leadDetailPage.tabBase')" name="base">

          <el-descriptions v-if="lead" :column="2" border>

            <el-descriptions-item :label="$t('leadDetailPage.leadNo')">{{ lead.leadNo }}</el-descriptions-item>

            <el-descriptions-item :label="$t('common.status')">{{ labelLeadStatus(lead.leadStatusCode) }}</el-descriptions-item>

            <el-descriptions-item :label="$t('common.firstName')">{{ lead.firstName }}</el-descriptions-item>

            <el-descriptions-item :label="$t('common.lastName')">{{ lead.lastName }}</el-descriptions-item>

            <el-descriptions-item :label="$t('leadListPage.salesOwner')">{{ lead.assignedSalesUserName || '—' }}</el-descriptions-item>

            <el-descriptions-item :label="$t('grid.email')">{{ lead.email }}</el-descriptions-item>

            <el-descriptions-item :label="$t('grid.phone')">{{ lead.phone }}</el-descriptions-item>

            <el-descriptions-item :label="$t('leadFormPage.addressLabel')" :span="2">{{
              lead.addressText || '—'
            }}</el-descriptions-item>

            <el-descriptions-item :label="$t('common.source')" :span="2">{{ lead.sourceText }}</el-descriptions-item>

            <el-descriptions-item :label="$t('leadFormPage.descriptionLabel')" :span="2">{{
              lead.descriptionText || '—'
            }}</el-descriptions-item>

            <el-descriptions-item :label="$t('leadListPage.appointmentDate')">{{ lead.appointmentDate || '—' }}</el-descriptions-item>

            <el-descriptions-item :label="$t('leadDetailPage.visitWindow')">{{ formatVisitWindow(lead) }}</el-descriptions-item>

            <el-descriptions-item :label="$t('leadDetailPage.googleCalendar')">

              <template v-if="lead.googleCalendarEventId">{{ $t('leadDetailPage.gcalSynced') }}</template>

              <template v-else-if="(lead.appointmentDate || lead.visitStartAt) && lead.assignedSalesUserId">{{ $t('leadDetailPage.gcalNotSynced') }}</template>

              <template v-else>—</template>

            </el-descriptions-item>

            <el-descriptions-item :label="$t('leadListPage.createdAt')">{{ formatDisplayDateTime(lead.createdAt) || '—' }}</el-descriptions-item>

          </el-descriptions>

        </el-tab-pane>



        <el-tab-pane :label="$t('leadDetailPage.tabFollow')" name="fu">

          <el-button type="primary" size="small" style="margin-bottom:10px;" @click="openFollow">{{ $t('leadDetailPage.writeFollow') }}</el-button>

          <el-timeline>

            <el-timeline-item v-for="f in followups" :key="f.id" :timestamp="formatDisplayDateTime(f.followupTime) || '—'" placement="top">

              <p>{{ f.content }}</p>

              <p class="lead-follow-meta">{{ labelFollowupType(f.followupTypeCode) }} · {{ $t('leadDetailPage.nextApptInline') }} {{ f.nextAppointmentDate || '—' }}</p>

            </el-timeline-item>

          </el-timeline>

        </el-tab-pane>



        <el-tab-pane :label="$t('leadDetailPage.tabNote')" name="note">

          <el-button type="primary" size="small" style="margin-bottom:10px;" @click="openNote">{{ $t('leadDetailPage.addNote') }}</el-button>

          <el-table :data="internalNotes" border size="small">

            <el-table-column prop="noteContent" :label="$t('grid.content')" />

            <el-table-column :label="$t('grid.time')" width="220">
              <template slot-scope="scope">{{ formatDisplayDateTime(scope.row.createdAt) || '—' }}</template>
            </el-table-column>

            <el-table-column prop="createdByUserName" :label="$t('grid.createdBy')" width="120" />

          </el-table>

        </el-tab-pane>

      </el-tabs>

    </el-card>



    <form-dialog :title="$t('leadDetailPage.followDialog')" :visible.sync="followVisible" width="560px">

      <el-form :model="followForm" label-width="110px">

        <el-form-item :label="$t('leadDetailPage.followTime')">

          <el-date-picker

            v-model="followForm.followupTime"

            type="datetime"

            format="MM/dd/yyyy hh:mm:ss A"

            value-format="yyyy-MM-dd HH:mm:ss"

            :placeholder="$t('leadDetailPage.followTimePh')"

            style="width:100%;"

            clearable

          />

        </el-form-item>

        <el-form-item :label="$t('leadDetailPage.followType')">

          <el-select v-model="followForm.followupTypeCode" :placeholder="$t('common.pleaseSelect')" style="width:100%;">

            <el-option v-for="o in followTypeOptions" :key="o.value" :label="o.label" :value="o.value" />

          </el-select>

        </el-form-item>

        <el-form-item :label="$t('leadDetailPage.followContent')">

          <el-input type="textarea" v-model="followForm.content" rows="4" :placeholder="$t('leadDetailPage.followContentPh')" />

        </el-form-item>

        <el-form-item :label="$t('leadDetailPage.nextAppt')">

          <el-date-picker

            v-model="followForm.nextAppointmentDate"

            type="date"

            value-format="yyyy-MM-dd"

            :placeholder="$t('common.optional')"

            style="width:100%;"

            clearable

          />

        </el-form-item>

      </el-form>

      <span slot="footer">

        <el-button @click="followVisible=false">{{ $t('common.cancel') }}</el-button>

        <el-button type="primary" :loading="followSaving" @click="saveFollow">{{ $t('common.save') }}</el-button>

      </span>

    </form-dialog>



    <form-dialog :title="$t('leadDetailPage.noteDialog')" :visible.sync="noteVisible" width="520px">

      <el-input type="textarea" v-model="noteForm.noteContent" rows="4" />

      <span slot="footer">

        <el-button @click="noteVisible=false">{{ $t('common.cancel') }}</el-button>

        <el-button type="primary" :loading="noteSaving" @click="saveNote">{{ $t('common.save') }}</el-button>

      </span>

    </form-dialog>

    <LeadQuoteDialog :visible.sync="leadQuoteDialogVisible" :lead-id="leadId" @saved="load" />

  </detail-page-shell>

</template>



<script>

import { getLeadDetail, addFollowup, addInternalNote } from '@/api/lead'

import { labelFollowupType, labelLeadStatus } from '@/utils/crmLabels'

import { formatUsd } from '@/utils/formatUsd'

import { formatDisplayDateTime } from '@/utils/formatDisplayDateTime'

import DetailPageShell from '@/components/DetailPageShell.vue'

import FormDialog from '@/components/FormDialog.vue'

import LeadQuoteDialog from '@/views/lead/LeadQuoteDialog.vue'



export default {

  name: 'LeadDetail',

  components: { DetailPageShell, FormDialog, LeadQuoteDialog },

  data() {

    return {

      loading: false,

      tab: 'base',

      lead: null,

      followups: [],

      internalNotes: [],

      followVisible: false,

      followSaving: false,

      noteVisible: false,

      noteSaving: false,

      followForm: {

        content: '',

        followupTypeCode: 1,

        followupTime: null,

        nextAppointmentDate: null

      },

      noteForm: { noteContent: '' },

      leadQuoteDialogVisible: false

    }

  },

  computed: {

    leadId() {

      return this.$route.params.id

    },

    followTypeOptions() {

      return [1, 2, 3, 5, 4].map(value => ({

        value,

        label: this.$t('enum.followupType.' + value)

      }))

    }

  },

  async created() {

    await this.load()

  },

  methods: {

    labelLeadStatus,

    labelFollowupType,

    formatUsd,

    formatVisitWindow(lead) {

      if (!lead || (!lead.visitStartAt && !lead.visitEndAt)) return '—'

      const fa = formatDisplayDateTime(lead.visitStartAt)

      const fb = formatDisplayDateTime(lead.visitEndAt)

      if (fa && fb) return `${fa} → ${fb}`

      return fa || fb || '—'

    },

    formatDisplayDateTime,

    formatNowDateTime() {

      const d = new Date()

      const pad = n => String(n).padStart(2, '0')

      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`

    },

    async load() {

      this.loading = true

      try {

        const resp = await getLeadDetail(this.leadId)

        this.lead = resp.lead

        this.followups = resp.followups || []

        this.internalNotes = resp.internalNotes || []

      } finally {

        this.loading = false

      }

    },

    openQuoteForLead() {

      this.leadQuoteDialogVisible = true

    },

    openFollow() {

      this.followForm = {

        content: '',

        followupTypeCode: 1,

        followupTime: this.formatNowDateTime(),

        nextAppointmentDate: null

      }

      this.followVisible = true

    },

    async saveFollow() {

      if (!this.followForm.content) {

        this.$message.warning(this.$t('leadDetailPage.needContent'))

        return

      }

      this.followSaving = true

      try {

        const payload = {

          content: this.followForm.content,

          followupTypeCode: this.followForm.followupTypeCode

        }

        if (this.followForm.followupTime) {

          payload.followupTime = this.followForm.followupTime

        }

        if (this.followForm.nextAppointmentDate) {

          payload.nextAppointmentDate = this.followForm.nextAppointmentDate

        }

        await addFollowup(this.leadId, payload)

        this.followVisible = false

        this.$message.success(this.$t('common.saved'))

        await this.load()

      } catch (e) {

        this.$message.error((e && e.message) || this.$t('common.failed'))

      } finally {

        this.followSaving = false

      }

    },

    openNote() {

      this.noteForm = { noteContent: '' }

      this.noteVisible = true

    },

    async saveNote() {

      if (!this.noteForm.noteContent) {

        this.$message.warning(this.$t('leadDetailPage.needNote'))

        return

      }

      this.noteSaving = true

      try {

        await addInternalNote(this.leadId, this.noteForm)

        this.noteVisible = false

        this.$message.success(this.$t('common.saved'))

        await this.load()

      } catch (e) {

        this.$message.error((e && e.message) || this.$t('common.failed'))

      } finally {

        this.noteSaving = false

      }

    }

  }

}

</script>

<style scoped>
.lead-follow-meta {
  margin: 0;
  font-size: 12px;
  color: var(--dark-text-sub, #8b95a1);
  line-height: 1.45;
}

</style>

